import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

/**
 * HTML sections are used to group thematically related content.
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/section#usage_notes
 * Sections should ideally contain a heading, although the use of a single header
 * per section is allowed.
 */
export const Section = styled.section`
  margin-bottom: 40px;
`;

const StyledHeader = styled.header`
  align-items: center;
  display: flex;
  height: 34px;
  justify-content: space-between;
  margin-bottom: 1em;
`;

export const SectionHeader = ({children}: {children: React.ReactNode}) => {
  return <StyledHeader>{children}</StyledHeader>;
};
